export const cycleList = [
    { label: '无', value: 'nothing' },
    { label: '每天', value: 'da' },
    { label: '每周', value: 'w' },
    { label: '每月', value: 'm' },
    { label: '每年', value: 'y' },
    { label: '每两周', value: 'ws2' },
    { label: '每三个月', value: 'm3' },
    { label: '每六个月', value: 'm6' },
    { label: '每周一', value: 'w1' },
    { label: '每周二', value: 'w2' },
    { label: '每周三', value: 'w3' },
    { label: '每周四', value: 'w4' },
    { label: '每周五', value: 'w5' },
    { label: '每周六', value: 'w6' },
    { label: '每周日', value: 'w7' },
]
export const cycleTypeList = [
    { label: '无', value: 1 },
    { label: '截止日期', value: 2 },
    { label: '周期数', value: 3 }
]
